/// <reference path="../security/authenticationProvider" />
module Cfnc.Security {
    "use strict";

   
    class RedirectService implements IRedirectService {
        static $inject: string[] = ["$window", "$location"];
        static serviceId: string = "redirectService";

        private redirectUrl: string;

        constructor(private $window: angular.IWindowService, private $location: angular.ILocationService) {
        }

        redirect(url?: string): void {
            if (url) {
                this.redirectUrl = url;
            }
            else {
                if (this.isExternal(this.redirectUrl))
                {
                    this.$window.location.href = this.redirectUrl;
                } else {
                    this.$location.url(this.redirectUrl);
                }
                this.clear();
            }
        }

        clear(): void {
            this.redirectUrl = null;
        }

        isExternal(url): boolean {
            var regex = /https?:\/\/((?:[\w\d-]+\.)+[\w\d]{2,})/i;
            var test = regex.exec(url);

            return test !== null && test[1] !== this.$location.host();
        }
    }

    angular.module("authentication").service(RedirectService.serviceId, RedirectService);
}